import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
const searchUrl = qualifyUrl("/views/search");
const fetchSearch = (searchId) => fetch("GET", `${searchUrl}/${searchId}`);
export default fetchSearch;
